import React, { useState, useEffect } from "react";
import { Box, Button, Image, Icon, IconButton } from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import DiscountImage from "../assets/discountposter.jpeg";
import { FaCaretUp, FaTimes } from "react-icons/fa";
import { px } from "framer-motion";

const DiscountTag = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Get gender from URL
  const searchParams = new URLSearchParams(location.search);
  const gender = searchParams.get("gender");
  const toggleDiscount = () => {
    setIsOpen((prev) => !prev);
  };

  // 🔔 Auto popup after 1 minute (for both login & non-login)
  useEffect(() => {
    const openTimer = setTimeout(() => {
      setIsOpen(true);

      // 👇 auto close after 2 seconds
      const closeTimer = setTimeout(() => {
        setIsOpen(false);
      }, 5000);

      return () => clearTimeout(closeTimer);
    }, 5000); // popup open after 5 sec (testing)

    return () => clearTimeout(openTimer);
  }, []);

  const handleNavigate = () => {
    if (gender === "Men") {
      navigate("/subscription");
    } else if (gender === "Women") {
      navigate("/products?offerfilter=upto50&gender=Women");
    } else {
      navigate("/products?offerfilter=upto50");
    }
  };

  return (
    <Box position="fixed" top="40%" right="0" zIndex="2000">
      {/* Side Button */}
      <Button
        onClick={toggleDiscount}
        bg="#000346"
        color="white"
        transform="rotate(-90deg)"
        transformOrigin="right center"
        position="fixed"
        right="6"
        top="40%"
        width="250px"
        height="50px"
        fontWeight="800"
        fontSize={20}
        borderRadius="0"
        zIndex="1008"
        _hover={{ bg: "#ffb700" }}
        rightIcon={<Icon as={FaCaretUp} />}
      >
        Get 20% Extra at ₹9/-
      </Button>

      {/* Popup */}
      {isOpen && (
        <Box
          position="fixed"
          top="60%"
          right="40px"
          transform="translateY(-50%)"
          boxShadow="xl"
          borderRadius="md"
          zIndex="2000"
        >
          <Box position="relative">
            {/* Image Button */}
            <Button onClick={handleNavigate} bg="transparent" p="0">
              <Image
                src={DiscountImage}
                alt="Discount Offer"
                borderRadius="md"
                width="600px"
              />
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default DiscountTag;
